












import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

export type TextRuleType = (value: string) => string | true;

@Component
export default class CustomTextField extends Vue {
  @Prop()
  private value!: string;

  @Prop()
  private rules!: TextRuleType[];

  @Prop()
  private label!: string;

  private get itemValue(): string {
    return this.value;
  }

  @Emit('change')
  private change(value: string): string {
    return value;
  }

  @Emit('input')
  private input(value: string): string {
    return value;
  }
}
